import gql from 'graphql-tag';

export const upsertRoleAssignmentsMutation = gql`
  mutation upsertRoleAssignments($resourceId: String!, $resourceType: String!, $assignments: [RoleAssignmentInput!]) {
    upsertRoleAssignments(resourceId: $resourceId, resourceType: $resourceType, assignments: $assignments) {
        resourceRoleAssignmentId
        isPrivate
        user {
          userId
        }
        team {
          teamId
        }
    }
  }
`;

const upsertRoleAssignments = () => ({
  mutation: upsertRoleAssignmentsMutation,
  module: 'users',
  buildVariables: (
  {
    resourceId,
    resourceType,
    assignments
  }) => (
  {
    resourceId,
    resourceType,
    assignments
  })
});

export default upsertRoleAssignments;